<template>
    <checkbox-input
        v-model="selected"
        name="activations[]"
        :value="activation.id"
        @toggle="toggleItem"
    />
</template>
<script>
    export default {
        props: {
            activation: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                selected: false,
            };
        },
        methods: {
            toggleItem() {
                this.$activationExceptionsEventBus.$emit('toggleActivationSelected', this.activation.id, this.selected);
            },
        },
    };
</script>
